import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Cookie, X } from 'lucide-react';
import { Button } from '@/components/ui/button';

const STORAGE_KEY = 'qf_cookie_consent_v1';

export function CookieBanner() {
    const [show, setShow] = useState(false);

    useEffect(() => {
        try {
            const v = localStorage.getItem(STORAGE_KEY);
            if (!v) {
                // small delay to avoid flashing on first paint
                const t = setTimeout(() => setShow(true), 700);
                return () => clearTimeout(t);
            }
        } catch (_e) { /* ignore */ }
    }, []);

    const accept = (level) => {
        try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify({
                level,                       // 'essential' | 'all'
                accepted_at: new Date().toISOString(),
                version: 'v1',
            }));
        } catch (_e) { /* ignore */ }
        setShow(false);
    };

    if (!show) return null;

    return (
        <div
            className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:bottom-6 z-50 max-w-md"
            role="dialog"
            aria-labelledby="qf-cookie-title"
            aria-describedby="qf-cookie-desc"
            data-testid="cookie-banner"
        >
            <div className="relative bg-white border border-slate-200 shadow-2xl rounded-2xl p-4 sm:p-5">
                <button
                    type="button"
                    onClick={() => accept('essential')}
                    className="absolute top-3 right-3 text-slate-400 hover:text-slate-700"
                    aria-label="Dismiss cookie banner"
                    data-testid="cookie-dismiss-button"
                >
                    <X className="h-4 w-4" />
                </button>
                <div className="flex items-start gap-3 pr-6">
                    <div className="h-9 w-9 rounded-full bg-amber-50 border border-amber-200 flex items-center justify-center shrink-0">
                        <Cookie className="h-4 w-4 text-amber-600" />
                    </div>
                    <div className="flex-1">
                        <h2 id="qf-cookie-title" className="font-display text-base text-slate-900">We use a few cookies</h2>
                        <p id="qf-cookie-desc" className="mt-1 text-sm text-slate-600">
                            QuotesFlow uses essential cookies to keep you signed in and minimal first-party analytics to improve the product. We do <b>not</b> use cross-site advertising cookies, and we do <b>not</b> sell your data. See our <Link to="/privacy" className="underline text-slate-900" data-testid="cookie-privacy-link">Privacy Policy</Link>.
                        </p>
                    </div>
                </div>
                <div className="mt-4 flex flex-col sm:flex-row gap-2">
                    <Button onClick={() => accept('essential')} variant="outline" className="flex-1" data-testid="cookie-essential-button">
                        Essential only
                    </Button>
                    <Button onClick={() => accept('all')} className="flex-1 bg-amber-500 hover:bg-amber-400 text-slate-950 font-semibold" data-testid="cookie-accept-all-button">
                        Accept all
                    </Button>
                </div>
            </div>
        </div>
    );
}
